import { flowCopy } from "../../utils/flowCopy";
import React, { useContext, useEffect, useState, useRef } from "react";

import CheckedIcon from "../../assets/icons/svg/CheckedIcon";
import FavoriteIcon from "../../assets/icons/svg/FavoriteIcon";
import { SessionContext } from "../../context/SessionContext";
import localizationStrings from "../../statics/localization";
import { sendCustomFavoriteReport } from "../../utils/reporting/customReporting";
import { toggleFavById } from "../../api/vod/vod";

const FavoriteAction = ({ vod, newVodDetail }) => {
  const { setIsChangeFavList, setShowLoginMessage, hasLoggedIn } =
    useContext(SessionContext);
  const version = useRef(0);
  const pending = useRef(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(false);
  const [isFav, setIsFav] = useState(false);

  useEffect(() => {
    version.current++;
    pending.current = false;
    setBusy(false);
    setError(false);
    let vodStatus = vod?.interactions;

    let hasFav =
      vodStatus?.length &&
      vodStatus.find((element) => element?.type === "VOD_WATCHLIST");
    setIsFav(!!hasFav);
    return () => { version.current++; };
  }, [vod]);

  const toggleContentOfFavorite = async () => {
    if (!hasLoggedIn) { setShowLoginMessage(true); return; }
    if (!vod?.id || pending.current) return;
    pending.current = true;
    setBusy(true);
    setError(false);
    const request = version.current;
    try {
      const response = await toggleFavById(vod.id);
      if (response?.data?.IsSucceeded === false || response?.data?.isSucceeded === false) throw new Error("Rejected");
      if (request !== version.current) return;
      setIsFav(value => !value);
      setIsChangeFavList(true);
      setIsChangeFavList(false);
    } catch (e) {
      if (request === version.current) setError(true);
    } finally {
      if (request === version.current) { pending.current = false; setBusy(false); }
    }
  };

  return (
    <>
    <button
      className={`action-button secondary ${isFav ? "selected" : ""}`}
      style={newVodDetail && isFav ? { backgroundColor: "#ffffff" } : {}}
      type="button" disabled={busy} aria-busy={busy} aria-pressed={isFav}
      aria-label={localizationStrings.inMyList}
      onClick={toggleContentOfFavorite}
    >
      <span className="icon">
        {!isFav ? <FavoriteIcon /> : <CheckedIcon />}
      </span>
      {newVodDetail || isFav ? (
        <span className={`action-label ${isFav ? "visible" : ""}`}>
          {localizationStrings.inMyList}
        </span>
      ) : null}
    </button>
    {error && <span role="alert">{flowCopy().error}</span>}
    </>
  );
};

export default FavoriteAction;
